module.exports = __webpack_public_path__ + "static/media/banner.d1006990.png";